export default __webpack_public_path__ + "static/media/todos.9cfa8a46.png";